import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useTendering() {
  const query = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const create = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/tenderings`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data.data;
  };

  const getSignedUrl = async (key, contentType) => {
    const result = await axios.get(
      `${apiUri}/api/v1/tenderings/signedUrl?key=${key}&contentType=${contentType}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const getById = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/tenderings/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data.data;
  };

  const update = async (_id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/tenderings/${_id}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const deleteById = async (id) => {
    const result = await axios.delete(`${apiUri}/api/v1/tenderings/${id}`, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  const participate = async (_id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participate`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const sendNDA = async (_id, userId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participants/${userId}/nda/send`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const signNDA = async (_id, userId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participants/${userId}/nda/sign`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const rejectParticipant = async (_id, userId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participants/${userId}/reject`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const requestQuotation = async (_id, userId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participants/${userId}/quotation/request`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const requestSchedule = async (_id, userId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participants/${userId}/schedule/request`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const submitSchedule = async (_id, userId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participants/${userId}/schedule/submit`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const selectWinner = async (_id, userId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/participants/${userId}/won`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const createContract = async (_id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/contract`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const signContract = async (_id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/contract/sign`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const submitWork = async (_id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/tenderings/${_id}/contractor/submissions`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const updateWork = async (_id, no, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.put(
      `${apiUri}/api/v1/tenderings/${_id}/contractor/submissions/${no}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const patchSubmissionWorkItem = async (_id, no, subjectId, itemId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/tenderings/${_id}/contractor/submissions/${no}/subjects/${subjectId}/items/${itemId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const approveSubmission = async (_id, no) => {
    const result = await axios.patch(
      `${apiUri}/api/v1/tenderings/${_id}/contractor/submissions/${no}/approve`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data;
  };

  return {
    query,
    getById,
    create,
    update,
    getSignedUrl,
    deleteById,
    participate,
    sendNDA,
    signNDA,
    submitSchedule,
    rejectParticipant,
    requestQuotation,
    requestSchedule,
    selectWinner,
    createContract,
    signContract,
    submitWork,
    updateWork,
    patchSubmissionWorkItem,
    approveSubmission,
  };
}
